import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import { Field } from 'formik'
import { reExportedColors } from '../index'
import OtherTextField from './OtherTextField'
import { useSelector } from '../../../common/redux.Interface.Component'

const fieldStyles = (theme, hasError) => ({
  border: `1px solid ${hasError
    ? reExportedColors.ERROR_RED
    : reExportedColors.DARK_GREY}`,
  borderRadius: 5,
  boxShadow: 'none',
  color: hasError ? reExportedColors.ERROR_RED : reExportedColors.TEXT,
  fontFamily: theme.fontFamily,
  height: 21,
  padding: '0 5px',
  '&:focus, &:hover': {
    boxShadow: `${theme.boxShadow} !important`
  }
})

const StyledField = styled(Field, {
  shouldForwardProp: prop => prop !== 'hasError'
})(({ theme, hasError }) => fieldStyles(theme, hasError))

const FormikField = ({
  name,
  className,
  validate,
  component,
  children,
  placeholder,
  required,
  type
}) => {
  const validationErrors = useSelector(state => state.tabs.validationErrors)
  const errorMsg = validationErrors ? validationErrors[name] : null

  const getComponentType = type => {
    let componentType = type.toLowerCase()
    switch (componentType) {
      case 'link':
        componentType = 'url'
        break
      case 'phone':
        componentType = 'tel'
        break
      case 'shortext':
      case 'longtext':
      case 'labelless':
        componentType = 'text'
        break
      default:
        componentType = type.toLowerCase()
        break
    }

    return componentType
  }

  if (component) {
    return (
      <StyledField
        name={name}
        className={className}
        validate={validate}
        component={component}
        placeholder={placeholder}
      >
        {children}
      </StyledField>
    )
  }

  if (!type) throw new Error('invalid field data type')

  return (
    <>
      <StyledField
        name={name}
        className={className}
        validate={validate}
        type={getComponentType(type)}
        required={required}
        component={OtherTextField}
        placeholder={placeholder}
        hasError={Boolean(errorMsg)}
      >
        {children}
      </StyledField>
      {errorMsg && (
        <Box component='div' sx={theme => fieldStyles(theme, true)}>
          {errorMsg}
        </Box>
      )}
    </>
  )
}

export default FormikField
